import reducers from "../slices/index";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
let middleware = [thunk];

const store = createStore(reducers, {}, applyMiddleware(...middleware));

export default store;